/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Session from '@/Session';
import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SearchCustomerOrders(parameters) {
  const response = await $.soap({
    body: {
      SearchCustomerOrders: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        CustomerOrderID: parameters?.customerOrderID,
        TypeID: parameters?.typeID,
        StatusID: parameters?.statusID,
        StatusGroupID: parameters?.statusGroupID,
        UserID: parameters?.userID,
        CommandID: Session.user?.actingAsCommandId,
        POPStartDateStart: parameters?.popStartDateStart,
        POPStartDateEnd: parameters?.popStartDateEnd,
        TrackerNumber: parameters?.trackerNumber
      }
    },
    blueprintArrays: ['SearchCustomerOrdersResponse.Response.tuple.old.rowset.row'],
    blueprint: {
      totalCount: '$..TotalCount',
      orders: [
        '$..old.rowset.row',
        {
          orderID: '$.ID',
          orderPackageID: '$.OrderPackageID',
          customerName: '$.CustomerName',
          orderType: '$.FormName',
          orderStatus: '$.InternalOrderStatus',
          assignedCRS: '$.CRSOwnerName',
          submittedOn: '$.SubmittedOn',
          regionID: '$.RegionID',
          regionName: '$.RegionName',
          extOrderStatus: '$.ExternalOrderStatus',
          popStartDate: '$.POPDate',
          commandName: '$.CommandName',
          commandId: '$.CommandID',
          trackerNumber: '$.TrackerNumber',
          customerResponsibilitiesDocument: {
            attachmentId: '$.CustomerResponsibilityAttachmentID',
            fileName: '$.CustomerResponsibilityFileName'
          }
        }
      ]
    }
  });
  cleanUpResponse(response);
  if (!response.totalCount) {
    response.totalCount = 0;
  }
  return response;
}
